import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Button from "@material-ui/core/Button";
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import {useHistory} from "react-router-dom";
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import './HomePageStyle.css'

const useStyles1 = makeStyles(theme => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const {count, page, rowsPerPage, onChangePage} = props;

    const handleFirstPageButtonClick = event => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = event => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = event => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = event => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon/> : <FirstPageIcon/>}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight/> : <KeyboardArrowLeft/>}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft/> : <KeyboardArrowRight/>}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon/> : <LastPageIcon/>}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles({
    table: {
        minWidth: 500,
    },
});

export default function FutureSessionsTable(sessions) {
    const classes = useStyles2();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(4);

    const authenticated = sessions.authenticated;

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, sessions.sessions.length - page * rowsPerPage);
    const currentSessions = sessions.sessions;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const history = useHistory();

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <TableContainer className="tableContainer" component={Paper}>
            <Table className={classes.table} aria-label="custom pagination table" size="small">
                <TableHead>
                    <TableRow>
                        <TableCell className="tableHeaderCell"></TableCell>
                        <TableCell align="right" className="tableHeaderCell">מועד</TableCell>
                        <TableCell align="right" className="tableHeaderCell">שם התכנית</TableCell>
                        <TableCell align="right" className="tableHeaderCell">תאריך</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(rowsPerPage > 0
                            ? currentSessions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : currentSessions
                    ).map((row, i) => (
                        <TableRow key={i}>
                            <TableCell align="right" className="tableCell" component="th" scope="row">
                                <Button
                                    style={{textDecoration: 'none', color: 'black', fontSize: '14px'}}
                                    onClick={() => history.push({
                                        pathname: "/teamSessions",
                                        state: {
                                            id: row.id,
                                            isAuthenticated: authenticated,
                                            appBarData: row.program + ' - ' + row.date + ' - ' + row.time
                                        }
                                    })}>
                                    <div className="Arrow">
                                        <ArrowBackIos style={{fontSize: '14px'}}/>
                                    </div>
                                    <div className="SeeSession">
                                        ראה שיבוץ
                                    </div>
                                </Button>
                            </TableCell>
                            <TableCell align="right" className="tableCell">{row.time}</TableCell>
                            <TableCell align="right" className="tableCell">{row.program}</TableCell>
                            <TableCell align="right" className="tableCell">{row.date}</TableCell>
                        </TableRow>
                    ))}

                    {emptyRows > 0 && (
                        <TableRow style={{height: 53 * emptyRows}}>
                            <TableCell colSpan={6}/>
                        </TableRow>
                    )}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            dir="rtl"
                            labelDisplayedRows={({from, to, count}) => `   ${from}-${to} מתוך ${count} `}
                            rowsPerPageOptions={[4, 8, 12, {label: 'הצג הכל', value: -1}]}
                            colSpan={3}
                            count={sessions.sessions.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="מספר שורות בעמוד"
                            style={{borderColor: "azure"}}
                            page={page}
                            SelectProps={{
                                inputProps: {'aria-label': 'rows per page'},
                                native: true,
                            }}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                            className="Pagination"
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
}
